export default __webpack_public_path__ + "static/media/OS.92c572f2.jpg";